import { WorksProfileType } from '@clinician-profile/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

const WorksProfilesQuery = gql`
  query WorksProfilesQuery {
    worksProfiles {
      id
      firstName
      lastName
      fullName
      phone
      email
    }
  }
`;

const PaginatedCandidatesQuery: TypedDocumentNode<PaginatedCandidatesResponse> = gql`
  query PaginatedCandidatesQuery(
    $limit: Int!
    $offset: Int!
    $orderField: WorksProfileOrderField
    $orderDirection: OrderDirection
    $filters: WorksProfileFiltersInput
  ) {
    paginatedWorksProfiles(
      limit: $limit
      offset: $offset
      orderField: $orderField
      orderDirection: $orderDirection
      filters: $filters
    ) {
      worksProfiles {
        id
        firstName
        lastName
        fullName
        phone
        email
        createdAt
        role {
          id
          abbreviation
        }
        primarySpecialty {
          id
          displayName
        }
      }
      totalCount
    }
  }
`;

export type PaginatedCandidatesResponse = {
  paginatedWorksProfiles: {
    worksProfiles: WorksProfileType[];
    totalCount: number;
  };
};

const PaginatedWorksProfileQuery = gql`
  query PaginatedWorksProfileQuery(
    $limit: Int!
    $offset: Int!
    $staffingRequestId: ID
  ) {
    paginatedWorksProfiles(
      limit: $limit
      offset: $offset
      staffingRequestId: $staffingRequestId
    ) {
      worksProfiles {
        id
        firstName
        lastName
        fullName
        phone
        email
        currentStaffingRequestAssignment {
          id
          startDate
          endDate
          supplier {
            id
            name
            timeZone
          }
        }
        activeSubmissionsCount
      }
      totalCount
    }
  }
`;

export {
  WorksProfilesQuery,
  PaginatedCandidatesQuery,
  PaginatedWorksProfileQuery,
};
